/* Two renders stacked in one frame; the upper one shows right of the handle only. */
.frame {
  position: relative;
  overflow: hidden;
  aspect-ratio: 16 / 9;
  border-radius: var(--radius-lg);
  box-shadow:
    0 0 0 1px var(--border),
    var(--shadow-lg);
  background: var(--surface-raised);
  cursor: ew-resize;
  user-select: none;
  -webkit-user-select: none;
  /* Vertical swipes still scroll the page; sideways ones move the handle. */
  touch-action: pan-y;
}
/* Both renders fill the frame and crop alike, so they stay registered at any shape. */
.frame .layer {
  position: absolute;
  inset: 0;
  height: 100%;
}
.frame img {
  -webkit-user-drag: none;
  pointer-events: none;
}
.after {
  clip-path: inset(0 0 0 var(--pos));
}
.divider {
  position: absolute;
  top: 0;
  bottom: 0;
  left: var(--pos);
  width: 2px;
  margin-left: -1px;
  background: #ffffff;
  box-shadow: 0 0 0 1px rgba(8, 13, 19, 0.25);
  pointer-events: none;
}
.handle {
  position: absolute;
  top: 50%;
  left: var(--pos);
  display: grid;
  place-items: center;
  width: 3rem;
  height: 3rem;
  translate: -50% -50%;
  border-radius: 50%;
  background: #ffffff;
  color: #0b0e12;
  box-shadow: 0 6px 24px rgba(8, 13, 19, 0.35);
  pointer-events: none;
}
/* The range input underneath has the keyboard focus; the handle shows it. */
.frame:has(.range:focus-visible) .handle {
  outline: 3px solid var(--focus, var(--accent));
  outline-offset: 3px;
}
.tag {
  position: absolute;
  top: var(--sp-4);
  padding: var(--sp-1) var(--sp-3);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: var(--radius);
  background: rgba(8, 13, 19, 0.72);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  color: #f5f7fa;
  font-size: var(--fs-sm);
  font-weight: 600;
  pointer-events: none;
  transition: opacity var(--dur) var(--ease);
}
.tagBefore {
  left: var(--sp-4);
}
.tagAfter {
  right: var(--sp-4);
}
.tag[data-hidden] {
  opacity: 0;
}
/* Present for the keyboard and screen readers, invisible to the eye and the pointer. */
.range {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  opacity: 0;
  pointer-events: none;
}
@media (max-width: 47.99rem) {
  /* Taller on a phone, cropped the same on both renders. */
  .frame {
    aspect-ratio: 4 / 3;
  }
  .tag {
    top: var(--sp-3);
    font-size: 0.75rem;
  }
  .tagBefore {
    left: var(--sp-3);
  }
  .tagAfter {
    right: var(--sp-3);
  }
}
